var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEarly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3281 115.266V122.359H45.5938V119.609H43.0469C42.7031 121.148 41.2656 122.164 39.4219 122.172C37.2812 122.164 35.6875 120.828 35.6875 118.906C35.6875 117.023 37.2812 115.703 39.4219 115.703C41.2578 115.703 42.6875 116.703 43.0391 118.203H45.5938V115.266H47.3281ZM37.3438 118.906C37.3438 120.039 38.2109 120.75 39.4219 120.75C40.5938 120.75 41.4609 120.039 41.4688 118.906C41.4609 117.828 40.5938 117.109 39.4219 117.109C38.2109 117.109 37.3438 117.828 37.3438 118.906ZM38.0156 124.391V123.047H47.3281V126.703H39.7656V127.844H47.7812V129.219H38.0312V125.422H45.5938V124.391H38.0156ZM61.0938 115.266V129.406H59.375V115.266H61.0938ZM50.0938 117.906V116.5H56.75V121.797H51.8906V124.641C54.1172 124.625 56.0312 124.508 58.2344 124.141L58.3906 125.562C55.9922 125.977 53.8828 126.07 51.3438 126.062H50.1094V120.422H54.9844V117.906H50.0938ZM67.0156 116.297C68.9219 116.297 70.3359 117.891 70.5859 120.469H73.2812V115.266H75V129.406H73.2812V121.875H70.6016C70.4141 124.602 68.9766 126.281 67.0156 126.281C64.8906 126.281 63.3828 124.352 63.3906 121.281C63.3828 118.234 64.8906 116.297 67.0156 116.297ZM65.0625 121.281C65.0547 123.453 65.8516 124.711 67.0156 124.719C68.1875 124.711 68.9766 123.453 68.9844 121.281C68.9766 119.125 68.1875 117.859 67.0156 117.859C65.8516 117.859 65.0547 119.125 65.0625 121.281ZM92.6094 124.297V129.406H90.875V125.688H82.9844V124.297H92.6094ZM81.3906 122.781V116.297H88.0312V118.703H90.875V115.266H92.6094V123.609H90.875V120.109H88.0312V122.781H81.3906ZM83.125 121.406H86.3125V117.703H83.125V121.406ZM106.453 115.266V129.406H104.734V121.781H102.078V120.375H104.734V115.266H106.453ZM95.25 126.156V116.484H101.859V117.906H97V120.438H101.297V121.812H97V124.719C99.1484 124.711 100.758 124.633 102.578 124.344L102.75 125.75C100.695 126.062 98.8828 126.141 96.3594 126.156H95.25Z",
    fill: "#242424"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1275_5283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.019 49.0005C119.019 75.5258 97.5238 97.0205 70.9985 97.0205C44.4732 97.0205 22.9785 75.5258 22.9785 49.0005C22.9785 22.4751 44.4732 0.980469 70.9985 0.980469C97.5238 0.980469 119.019 22.4751 119.019 49.0005Z",
    fill: "url(#paint0_linear_1275_5283)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1275_5283)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70.9999,
    cy: 49.0009,
    r: 42.4906,
    stroke: "#98A2B3",
    strokeWidth: 2.56553
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1275_5283)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4494 16.8655L58.0585 19.4927C58.007 19.5957 57.9298 19.6473 57.801 19.673L54.8647 20.1882C54.0662 20.3169 53.3965 20.9094 53.1389 21.6821C52.8814 22.4548 53.0874 23.3048 53.6541 23.8972L55.7146 26.035C55.7919 26.1123 55.8177 26.2153 55.8177 26.3184L55.4056 29.2547C55.2768 30.0531 55.6374 30.8774 56.2813 31.3667C56.951 31.8561 57.8267 31.9334 58.5479 31.5728L61.2267 30.2592C61.3297 30.2077 61.4327 30.2077 61.5358 30.2592L64.2145 31.5728C64.9614 31.9334 65.8114 31.8561 66.4811 31.3667C67.1508 30.8774 67.4856 30.0789 67.3569 29.2547L66.9447 26.3184C66.919 26.2153 66.9705 26.1123 67.0478 26.035L69.1083 23.8972C69.675 23.3048 69.8811 22.4548 69.6235 21.6821C69.3659 20.9094 68.6962 20.3169 67.8978 20.1882L64.9615 19.673C64.8584 19.6473 64.7554 19.5957 64.7039 19.4927L63.313 16.8655C62.9266 16.1443 62.1797 15.6807 61.3555 15.6807C60.5827 15.6807 59.8358 16.1185 59.4494 16.8655Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.4397 16.8655L77.0488 19.4927C76.9973 19.5957 76.92 19.6473 76.7912 19.673L73.8549 20.1882C73.0564 20.3169 72.3867 20.9094 72.1292 21.6821C71.8716 22.4548 72.0777 23.3048 72.6443 23.8972L74.7049 26.035C74.7822 26.1123 74.8079 26.2153 74.8079 26.3184L74.3958 29.2547C74.267 30.0531 74.6276 30.8774 75.2715 31.3667C75.9412 31.8561 76.817 31.9334 77.5382 31.5728L80.2169 30.2592C80.3199 30.2077 80.423 30.2077 80.526 30.2592L83.2047 31.5728C83.9517 31.9334 84.8017 31.8561 85.4714 31.3667C86.141 30.8774 86.4759 30.0789 86.3471 29.2547L85.935 26.3184C85.9092 26.2153 85.9607 26.1123 86.038 26.035L88.0986 23.8972C88.6652 23.3048 88.8713 22.4548 88.6137 21.6821C88.3561 20.9094 87.6865 20.3169 86.888 20.1882L83.9517 19.673C83.8487 19.6473 83.7456 19.5957 83.6941 19.4927L82.3032 16.8655C81.9169 16.1443 81.1699 15.6807 80.3457 15.6807C79.573 15.6807 78.826 16.1185 78.4397 16.8655Z",
    fill: "#98A2B3"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1275_5283)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.7932 58.9264C93.7932 60.7809 92.5311 62.146 91.3978 63.3309C90.7796 63.9748 90.1615 64.6445 90.0069 65.1339C89.8424 65.6509 89.9352 66.468 90.031 67.3115C90.0402 67.3925 90.0494 67.4738 90.0584 67.555C90.2645 69.152 90.4706 70.9807 89.4403 72.4231C88.3662 73.8808 86.6066 74.2213 85.0186 74.5286L84.9843 74.5352C84.8842 74.5558 84.7835 74.5761 84.6828 74.5963L84.6823 74.5964L84.6817 74.5965L84.6816 74.5965C83.9022 74.7533 83.131 74.9085 82.7434 75.2049C82.3264 75.4993 81.9094 76.2609 81.4923 77.0225L81.4298 77.1367C80.6828 78.5791 79.7813 80.2018 78.0556 80.7684C77.6693 80.8972 77.2572 80.9487 76.8708 80.9487C75.6658 80.9487 74.5078 80.4087 73.4416 79.9115L73.2906 79.8412C72.4663 79.429 71.5906 79.0169 70.9982 79.0169C70.4058 79.0169 69.5558 79.429 68.7058 79.8412C67.2634 80.5366 65.6149 81.3093 63.9407 80.7684C62.215 80.2018 61.3393 78.5791 60.5665 77.1367L60.504 77.0225C60.087 76.2609 59.6699 75.4992 59.2529 75.2049C58.8151 74.87 57.9136 74.6897 57.0121 74.5352L56.9597 74.5251C55.3758 74.2187 53.6006 73.8752 52.5561 72.4231C51.5 70.9807 51.7318 69.152 51.9379 67.555L51.963 67.332C52.0596 66.4778 52.1553 65.6314 51.9894 65.1339C51.8471 64.6832 51.2897 64.0796 50.7398 63.484L50.5985 63.3309L50.5763 63.3071C49.4738 62.1278 48.2031 60.7685 48.2031 58.9264C48.2031 57.0719 49.4652 55.7068 50.5985 54.5219L50.7398 54.3688C51.2897 53.7732 51.8471 53.1696 51.9894 52.7189C52.1539 52.2019 52.0611 51.3848 51.9654 50.5413C51.9562 50.4603 51.9469 50.379 51.9379 50.2978C51.7318 48.7008 51.5258 46.8721 52.5561 45.4297C53.6301 43.972 55.3897 43.6315 56.9778 43.3242L57.0121 43.3176C57.1125 43.2969 57.2136 43.2766 57.3146 43.2563L57.3147 43.2562L57.3147 43.2562C58.0941 43.0994 58.8653 42.9443 59.2529 42.6479C59.6699 42.3535 60.087 41.5919 60.504 40.8303L60.5665 40.7161C61.3135 39.2737 62.215 37.651 63.9407 37.0844C65.5625 36.5354 67.136 37.2675 68.544 37.9226L68.68 37.9859C69.5043 38.398 70.38 38.8101 70.9724 38.8101C71.5614 38.8101 72.4306 38.4027 73.2506 38.0183L73.2648 38.0116C74.7072 37.3162 76.3557 36.5435 78.0299 37.0844C79.7814 37.651 80.6571 39.2737 81.4298 40.7161L81.4923 40.8303C81.9094 41.5919 82.3264 42.3535 82.7434 42.6479C83.1813 42.9827 84.0828 43.163 84.9843 43.3176L85.0367 43.3277C86.6205 43.6341 88.3958 43.9775 89.4403 45.4297C90.4963 46.8721 90.2645 48.7008 90.0584 50.2978L90.0334 50.5207C89.9368 51.375 89.8411 52.2213 90.0069 52.7189C90.1492 53.1696 90.7066 53.7732 91.2566 54.3688L91.3978 54.5219L91.42 54.5457C92.5225 55.725 93.7932 57.0843 93.7932 58.9264ZM74.448 55.1405C74.448 56.0162 73.7526 56.7117 72.8768 56.7117L69.889 56.6859V57.3299H70.9708C71.8465 57.3299 72.542 58.0253 72.542 58.901C72.542 59.7768 71.8465 60.4722 70.9708 60.4722H69.889V61.1162H72.8768C73.7526 61.1162 74.448 61.8116 74.448 62.6873C74.448 63.5631 73.7526 64.2585 72.8768 64.2585H68.3436C67.4678 64.2585 66.7724 63.5631 66.7724 62.6873V55.1405C66.7724 54.2648 67.4678 53.5693 68.3436 53.5693H72.8768C73.7526 53.5693 74.448 54.2648 74.448 55.1405ZM63.8108 53.5951C62.9351 53.5951 62.2396 54.2906 62.2396 55.1663V57.0723L60.6169 54.3678C60.2563 53.7754 59.5351 53.4663 58.8655 53.6724C58.1958 53.8527 57.7064 54.4709 57.7064 55.1921V62.7389C57.7064 63.6146 58.4018 64.3101 59.2776 64.3101C60.1533 64.3101 60.8488 63.6146 60.8488 62.7389V60.8329L62.4715 63.5374C62.7548 64.0268 63.2699 64.3101 63.8108 64.3101C63.9396 64.3101 64.0942 64.2843 64.2229 64.2586C64.8926 64.0783 65.382 63.4601 65.382 62.7389V55.1921C65.382 54.2906 64.6866 53.5951 63.8108 53.5951ZM81.1456 55.1663C81.1456 54.2906 81.8411 53.5951 82.7168 53.5951C83.5926 53.5951 84.288 54.2906 84.2365 55.1663V62.7131C84.2365 63.3828 83.8244 64.001 83.1804 64.2071C83.0259 64.2586 82.8456 64.2843 82.6911 64.2843C82.2274 64.2843 81.7638 64.0525 81.4547 63.6662L79.6775 61.3223L77.9002 63.6662C77.4881 64.2071 76.7927 64.4389 76.1487 64.2071C75.5306 63.9752 75.0927 63.3828 75.0927 62.7131V55.1663C75.0927 54.2906 75.7881 53.5951 76.6639 53.5951C77.5396 53.5951 78.2351 54.2906 78.2351 55.1663V58.0769L78.4411 57.7935C79.0335 57.0208 80.3472 57.0208 80.9396 57.7935L81.1456 58.0769V55.1663Z",
    fill: "#98A2B3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1275_5283",
    x: 27.2266,
    y: 5.22754,
    width: 87.5469,
    height: 88.5731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5283"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1275_5283",
    x: 53.0293,
    y: 15.6807,
    width: 35.6934,
    height: 17.1424,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5283"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1275_5283",
    x: 48.2031,
    y: 36.8916,
    width: 45.5898,
    height: 45.0848,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5283"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1275_5283",
    x1: 37.6785,
    y1: 11.4338,
    x2: 107.749,
    y2: 79.3805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC1CB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1275_5283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 98,
    fill: "white",
    transform: "translate(22)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarly);
export default __webpack_public_path__ + "static/media/Early.2f54071c46185edf3d0491035d6fe3c1.svg";
export { ForwardRef as ReactComponent };